import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ContactCTA = () => {
  return (
    <section className="py-24 bg-stone-900 relative overflow-hidden">
      {/* Subtle gradient accent overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-transparent to-purple-900/20" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-[0.2em] bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent uppercase mb-6">
            Start Your Journey
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-white mb-6">
            Ready to Find Your Dream Home?
          </h2>
          <p className="text-stone-400 leading-relaxed mb-10">
            Our team of experts is here to guide you through every step of your property journey. 
            Let's discuss how we can help you find the perfect home.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white text-sm font-medium tracking-wide rounded-sm hover:from-blue-600 hover:to-purple-600 transition-all duration-300 shadow-lg shadow-purple-500/25"
            >
              Get in Touch
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
            <Link
              to="/projects"
              className="inline-flex items-center gap-3 px-8 py-4 border border-stone-700 text-white text-sm font-medium tracking-wide rounded-sm hover:bg-white/5 hover:border-stone-600 transition-all duration-300"
            >
              Browse Projects
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
